import { filterByTruthyValues } from './filterByTruthyValues';
import { deepCopy, __cloneDeep, __isEqual } from '.';

const prepareFiltersForPostService = (
  filtersValues,
  filters,
  siteFilters = false
) => {
  const filtersData = [];
  Object.values(filtersValues).map((fv) => {
    const value = fv.value;
    if (value) {
      if (typeof value === 'object') {
        if (Array.isArray(value) && value.length) {
          // type:3, 1

          if (filters.find((it) => it._id === fv._id)?.type === 10) {
            if (siteFilters === true) {
              filtersData.push({
                _id: fv._id,
                values: [{ valueText: value[0]?.value }],
              });
            }
          } else {
            const valuesArr = [];
            value.map((__value) => valuesArr.push({ value: __value.value }));
            filtersData.push({ _id: fv._id, values: valuesArr });
          }
        } else if (value.value) {
          // type: 4
          filtersData.push({ _id: fv._id, values: [{ value: value.value }] });
        }
      } else {
        // type:2
        // probably type 10
        if (filters.find((it) => it._id === fv._id)?.type === 10) {
          // console.log("Aw")
          if (siteFilters === true) {
            filtersData.push({ _id: fv._id, values: [{ valueText: value }] });
          }
        } else {
          filtersData.push({ _id: fv._id, values: [{ value }] });
        }
      }
    }
  });
  return filtersData;
};


const prepareOptionFilters = (option_filters) => {
  const optionsData = [];
  option_filters.map(o => {
    if (o.filterName !== "" || o.value !== "" ) {
      optionsData.push(o);
    }
  })
  return optionsData;
};

const prepareInventoryFiltersForPostService = (inventoryFilters) => {
  const _inventoryFilters = JSON.parse(JSON.stringify(inventoryFilters));
  const arr = [];
  _inventoryFilters.map((inv) => {
    delete inv['unit'];
    delete inv['_id'];
    const data = { ...inv };
    const filters = [];
    inv.filters.map((f) => {
      filters.push({
        value: f.value,
        _id: f._id,
      });
    });
    data['filters'] = filters;
    arr.push(data);
  });
  return arr;
};

const getInventoryAvailableFilters = (filtersValues = {}, filters = []) =>
  filters.filter(
    (f) =>
      f.option &&
      filtersValues[f._id] &&
      (Array.isArray(filtersValues[f._id].value)
        ? filtersValues[f._id].value.length
        : filtersValues[f._id].value)
  );

const getInventoryAvailableFiltersValues = (
  filtersValues = {},
  inventoryAvailableFilters
) =>
  filterByTruthyValues(filtersValues, (f) =>
    filtersValues[f._id]
      ? Array.isArray(filtersValues[f._id].value)
        ? filtersValues[f._id].value.length
        : filtersValues[f._id].value
      : false
  ).filter(
    (fil) =>
      inventoryAvailableFilters.filter((ifil) => ifil._id === fil._id).length
  );

/**
 * @example <caption>اینجا رو ببین: </caption>
 * @link https://stackoverflow.com/questions/53311809/all-possible-combinations-of-a-2d-array-in-javascript/53311986#53311986
 */
function combos(list, n = 0, result = [], current = []) {
  if (n === list.length) result.push(current);
  else
    list[n].forEach((item) => combos(list, n + 1, result, [...current, item]));
  return result;
}

/**
 *
 * @param {Array} filtersValues آرایه ولیو های فیلتر ها
 * @returns چند تایی های اینونتوری
 * @example <caption> این فانکشن برای اینه که چند تایی ها رو بسازیم ،مثلا اگر از پرنت ولیو فیلتر ها این ها بیاد : </caption>
 * filtersValues = [
 *   { filterName: "سایز", value: [ { name: "لارج" }, { name: "اسمال" } ] },
 *   { filterName: "رنگ", value: [ { name: "مشکی" }, { name: "طوسی" } ] }
 * ]
 * این فانکشن این چند تایی های زیر رو میسازه :
 * permutes = [{
 *   filters: [
 *     { name: "اسمال", value: x, _id: "*" },
 *     { name: "مشکی", value: x, _id: "*" }
 *   ],
 *   price: "empty", inventories: "empty"
 *  },
 *  {
 *    filters: [
 *      { name: "لارج", value: x, _id: "*" },
 *      { name: "قرمز", value: x, _id: "*" }
 *    ],
 *    price: "empty", inventories: "empty"
 *  }
 *  ...,
 *  ...
 * ]
 */
function getPermutes(filtersValues) {
  return combos(
    filtersValues.map((fv) => {
      fv.value.map((fvv) => (fvv._id = fv._id));
      return fv.value;
    })
  );
}

// این هلپر برای اینه که وقتی از بک فیلتر های تایپ سه اینجوری جدا جدا میان بهشون ساختار درست بدیم و بچسبونیمشون ب همدیگه:
// { filterName: "سایز", name: "بزرگ", value: 1}
// { filterName: "سایز", name: "سلام علیکم", value: 5}
// { filterName: "تست مالتی سلکت", name: "تستی مستی", value: 3}
// { filterName: "تست مالتی سلکت", name: "سلام علیکم", value: 5}
// const compactType3Filters = (filters = [], type3Filters = {}) => {
//   const _type3Filters = __cloneDeep(type3Filters);
//   filters.map(({ filterType, value, filterName, _id, name }) => {
//     if (filterType !== 3) return null;
//     _type3Filters[_id] = {
//       _id,
//       filterName,
//       value: [
//         ...(_type3Filters[_id] ? _type3Filters[_id].value : []),
//         { name, value, _id },
//       ],
//     };
//   });
//   return _type3Filters;
// };

// این هلپر برای اینه که وقتی از بک فیلتر های تایپ سه اینجوری جدا جدا میان بهشون ساختار درست بدیم
// تفاوتش با هلپر بالایی اینه که اینجا فیلتر های تایپ های دیگه هم هستن و فقط تایپ مالتی سلکت نیست.:
// { _id: '600fc0e550abe2237cc8f818', filterName: 'رنگ', filterType: 3, name: 'طوسی', value: 4 },
// { _id: '600fc0e550abe2237cc8f818', filterName: 'رنگ', filterType: 3, name: 'آبی', value: 1 },
// { _id: '600fc0e550abe2237cc8f818', filterName: 'رنگ', filterType: 3, name: 'مشکی', value: 2 },
// { _id: '60278778514d2e13a0c7e7d2', filterName: 'ظرفیت حافظه RAM', filterType: 1, name: '32 گیگابایت', value: 3 },
// { _id: '6027d68f514d2e13a0c7e7d4', filterName: 'ظرفیت', filterType: 1, name: '500 گیگابایت', value: 1 },
/**
 *
 * این هلپر برای اینه که وقتی از بک فیلتر های تایپ سه اینجوری جدا جدا میان بهشون ساختار درست بدیم تفاوتش با هلپر بالایی اینه که اینجا فیلتر های تایپ های دیگه هم هستن و فقط تایپ مالتی سلکت نیست.
 * @param {Array} filters آرایه فیلتر ها
 * @param {Array} alreadyCompactedFilters آبجکت فیلتر هایی که قبلا کامپکت شدن
 * @returns فیلتر های کامپکت شده
 * @example <caption> مثلا وقتی فیلتر ها از بک اینجوری جدا میاد از این هلپر استفاده میکنیم </caption>
 * filters = [
 *   { _id: '600fc0e550abe2237cc8f818', filterName: 'رنگ', filterType: 3, name: 'طوسی', value: 4 },
 *   { _id: '600fc0e550abe2237cc8f818', filterName: 'رنگ', filterType: 3, name: 'آبی', value: 1 },
 *   { _id: '600fc0e550abe2237cc8f818', filterName: 'رنگ', filterType: 3, name: 'مشکی', value: 2 },
 *   { _id: '60278778514d2e13a0c7e7d2', filterName: 'ظرفیت حافظه RAM', filterType: 1, name: '32 گیگابایت', value: 3 },
 *   { _id: '6027d68f514d2e13a0c7e7d4', filterName: 'ظرفیت', filterType: 1, name: '500 گیگابایت', value: 1 }
 * ]
 */
const compactWithType3Filters = (
  filters = [],
  alreadyCompactedFilters = {}
) => {
  const _filters = __cloneDeep(alreadyCompactedFilters);

  filters.map(({ filterType, value, filterName, _id, name }) => {
    _filters[_id] = {
      _id,
      filterName,
      value: [
        ...(_filters[_id] ? _filters[_id].value : []),
        { name, value, _id },
      ],
    };
  });
  return _filters;
};

/**
 *
 *  این هلپر برای ساخت لیست اینونتوری ها بر اساس پرمیوت هستش
 * @param {Array} permutes آرایه پرمیوت ها
 * @returns لیست اینونتوری
 * @example نمونه دیتای خروجی
 *  [
 * {
 * count: null
 *  filters: [
 *    {name: 'کوچک', value: 3, _id: '...'}
 *  ]
 * price: null
 * unit: "ریال"
 * },
 * {...}
 * ]
 *
 */
const getInventoryFiltersList = (permutes, inventoryList) => {
  const list = [];
  const _inventoryList = deepCopy(inventoryList);

  permutes.map((permute, index) => {
    const filters = [];
    const obj = {};
    obj.price = null;
    obj.unit = 'تومان';
    obj.inventory = 0;

    permute.map((p, ii) => {
      filters.push(p);
    });

    obj.filters = filters;
    list.push(obj);
  });

  if (list.length === _inventoryList.length) {
    list.map((listItem, listIndex) => {
      listItem['price'] = _inventoryList[listIndex]['price'];
      listItem['inventory'] = _inventoryList[listIndex]['inventory'];
    });
  }

  return list;
};

/**
 *
 *  این هلپر  لیست فیلتر ایدی های اینوتوری ها رو میسازه تا با فیلتر های سرویس یونید بررسی شه آیا میشه در یونید پست شه یا نه
 * @param {Array} inventoryFilters آرایه اینونتوری فیلترها
 * @returns {Array} لیستی از ایدی های فیلتر های اینوتوری ها
 */

const generateCheckUneedFilters = (inventoryFilters) => {
  const filtered = [];
  inventoryFilters.map((inventoryItem, index) => {
    inventoryItem.filters.map((filter) => {
      if (filtered.indexOf(filter._id) === -1) {
        filtered.push(filter._id);
      }
    });
  });

  return filtered;
};

const addNameToInventoryFilters = (invFilters, filters = null) => {
  const new_arr = [];
  const _invFilters = deepCopy(invFilters);

  _invFilters.map((inv) => {
    const newInvData = { ...inv };
    const newFiltersArr = [];
    inv.filters.map((f, f_i) => {
      const filterId = f._id;
      const filterValue = f.value;
      const filterObj = filters.find(
        (fil) => fil._id === filterId && fil.value === filterValue
      );
      newFiltersArr.push({
        name: filterObj?.name,
        ...f,
      });
    });

    newInvData['filters'] = newFiltersArr;
    new_arr.push(newInvData);
  });

  return new_arr;
};

/**
 *
 * این هلپر برای ایجاد لیست فیلتر های محصول در ایجاد فاکتور هستنش
*  @returns {Array} [
 ** [
**
 ** {
 **   name: "رنگ",
      _id: "..."
 **   values: [
 **     {
 **       name: "مشکی", value: 1
 **     },
 **     {
 **       name: "قرمز", value: 2
 **     },
 **   ]
 ** },
 **  
 **   ]
]
]
 */
const generateFactorFiltersList = (postChainFilters, inventoryFilters) => {
  const factorFilters = [];
  const _postChainFilters = deepCopy(postChainFilters);
  const INV_Ids = [];
  inventoryFilters.map((inv_filter) => {
    inv_filter.filters.map((ff) => {
      if (INV_Ids.indexOf(ff._id) === -1) {
        INV_Ids.push(ff._id);
      }
    });
  });

  _postChainFilters.map((postFilter) => {
    // Is Inventory Filter
    if (INV_Ids.indexOf(postFilter._id) !== -1) {
      if (!factorFilters.find((el) => el._id === postFilter._id)) {
        const newData = {
          name: postFilter.filterName,
          _id: postFilter._id,
          values: _postChainFilters
            .filter((f) => f._id === postFilter._id)
            .map((f_value) => ({
              name: f_value.name,
              value: f_value.value,
            })),
        };
        if (factorFilters.findIndex((el) => el._id === postFilter._id) === -1) {
          factorFilters.push(newData);
        }
      }
    }
  });

  return factorFilters;
};

export {
  combos,
  getPermutes,
  prepareFiltersForPostService,
  getInventoryAvailableFilters,
  getInventoryAvailableFiltersValues,
  compactWithType3Filters,
  getInventoryFiltersList,
  prepareInventoryFiltersForPostService,
  generateCheckUneedFilters,
  addNameToInventoryFilters,
  generateFactorFiltersList,
  prepareOptionFilters,
};
